<template>
    <div class="simple-form">
        <div class="form-group">
            <div class="form-label">
                <label>名称：</label>
            </div>
            <div class="form-value">
                <span>{{devcBrand.name}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>编码：</label>
            </div>
            <div class="form-value">
                <span>{{devcBrand.code}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>关联平台品牌：</label>
            </div>
            <div class="form-value">
                <span>{{devcBrand.sysBrandName}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>创建人：</label>
            </div>
            <div class="form-value">
                <span>{{devcBrand.creatorName}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>创建时间：</label>
            </div>
            <div class="form-value">
                <span>{{devcBrand.createTime}}</span>
            </div>
        </div>
    </div>
</template>
<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import shopDevcApi from '../../api/shopDevc'

    export default{
        name: 'swb-devc-brand-detail',
        desc: '自有资产品牌详情',
        props: {
            id: {
                type: Number,
                default: null
            }
        },
        data: function () {
            return {
                devcBrand: {}
            }
        },
        created: function () {
            this.getDevcCatDetail();
        },
        methods: {
            getDevcCatDetail: function () {
                let self = this;
                let postData = {};
                postData.id = self.id;
                //
                let msgBoxDlg = MsgBox.loading();
                shopDevcApi.getDevcBrandById(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type == 'info') {
                        self.devcBrand = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/categ/DevcBrandDetail.vue